import React from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Box, Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useFormikContext } from "formik";
import { IProfileIndustryData } from "store/types/user/social";

import { IFormikValues } from "../EditWindow";

export const IndustryExpertise: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IFormikValues>();

  const tableCellCommonStyle = {
    padding: 0,
    color: "#bac7ce",
    fontSize: "13px"
  };

  const rowBuilder = (data: IProfileIndustryData, index: number) => {
    const { title } = data;
    return (
      <TableRow key={index}>
        <TableCell sx={{ ...tableCellCommonStyle }}>
          {values.industry_expertises[index].operational &&
            values.industry_expertises[index].investment &&
            values.industry_expertises[index].learn_more && <DoneIcon sx={{ color: "#048365" }} />}
        </TableCell>
        <TableCell
          sx={{
            ...tableCellCommonStyle,
            color: "#0a3142",
            padding: "11px 0 11px 0 !important",
            textAlign: "left !important"
          }}
          align="center"
        >
          {title}
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          <Checkbox
            onChange={() => {
              setFieldValue(
                `industry_expertises[${index}].operational`,
                !values.industry_expertises[index].operational
              );
            }}
            checked={values.industry_expertises[index].operational}
            sx={{
              width: "20px",
              height: "20px"
            }}
          />
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          <Checkbox
            onChange={() => {
              setFieldValue(`industry_expertises[${index}].investment`, !values.industry_expertises[index].investment);
            }}
            checked={values.industry_expertises[index].investment}
            sx={{
              width: "20px",
              height: "20px"
            }}
          />
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          <Checkbox
            onChange={() => {
              setFieldValue(`industry_expertises[${index}].learn_more`, !values.industry_expertises[index].learn_more);
            }}
            checked={values.industry_expertises[index].learn_more}
            sx={{
              width: "20px",
              height: "20px"
            }}
          />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "32px" }}>
        <Table sx={{ width: "100%" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...tableCellCommonStyle, width: "7%" }}></TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "38%" }} align="left">
                Type
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "19%" }} align="center">
                Operational
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "19%" }} align="center">
                Investment
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "19%" }} align="center">
                Interested
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{values?.industry_expertises.map((row, index) => rowBuilder(row, index))}</TableBody>
        </Table>
      </Box>
    </div>
  );
};
